import React from "react";
import styled from "styled-components";


export const ValueColumn = styled.div`
    display: flex;
    justify-content: flex-end;
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 10px;
    text-align: right;
`;

export const ValueCell = styled(ValueColumn)`
    font-size: 12px;
`;
